import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import '../styles/Navbar.css'

import logo from '../images/logo.svg'
import userIcon from '../images/user-icon.svg'
import arrowDown from '../images/arrow-down.svg'
import { Cookies } from "react-cookie";
import UserDropdownMenu from "./UserDropdownMenu";

export default function Navbar({ setGoalType }: any) {

    let navigate = useNavigate();
    const location = useLocation();
    const cookies = new Cookies();

    const [activePage, setActivePage] = useState(location.pathname)
    const [showUserDropdownMenu, setShowUserDropdownMenu] = useState(false)

    useEffect(() => {
        setActivePage(location.pathname)
        if (setGoalType) {
            if (location.pathname.includes('/common_goal/')) {
                setGoalType(0)
            } else if (location.pathname.includes('/individual_goal/')) {
                setGoalType(1)
            }
        }
    }, [location.pathname])

    let handlePageChange = (page: string) => {
        if (page !== activePage) {
            setActivePage(`/${page}`)
            navigate(`/${page}`, { replace: true })
        }
    }

    let handleLogout = () => {
        cookies.remove('user', { path: '/', secure: true, sameSite: 'strict' })
        navigate(`/`)
    }

    const handleUserDropdownMenu = () => {
        setShowUserDropdownMenu(prev => !prev)
    }

    let userDropDownMenuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        document.addEventListener("mousedown", (event) => {
            if (userDropDownMenuRef?.current && !userDropDownMenuRef?.current.contains(event.target as Element)) {
                setShowUserDropdownMenu(false);
            }
        })
    })


    return (
        <div className="Navbar">
            <div className="Navbar-left-container">
                <div className="Navbar-logo">
                    <img src={logo} alt="GoalTODO Logo" />
                </div>
                <div className="Navbar-links">
                    <div className={(activePage.startsWith(`/curriculum`)) ? "link link active" : "link"}>
                        <button onClick={() => handlePageChange('curriculum')}>สถานภาพนิสิต</button >
                    </div>
                    <div className={(activePage.startsWith(`/scholarship`)) ? "link link active" : "link"}>
                        <button onClick={() => handlePageChange('scholarship')}>ทุนการศึกษา</button >
                    </div>
                </div>
            </div>
            <div className="Navbar-user-container" ref={userDropDownMenuRef}>
                <button className="Navbar-user-menu" onClick={handleUserDropdownMenu}>
                    <img src={userIcon} alt="" />
                    <p className="Navbar-user-name">{cookies.get('user')?.firstName}</p>
                    <img src={arrowDown} alt="" />
                </button>
                {showUserDropdownMenu && <UserDropdownMenu handleLogout={handleLogout} />}
            </div>
        </div>
    );
}